<div class="cont">
	<app-loading *ngIf="loading"></app-loading>

	<h2>Enter New Password </h2>
	<form class="k-form" [formGroup]="mainForm">
		<fieldset class="k-form-fieldset">
			<legend class="k-form-legend">Enter your email address below</legend>
			<kendo-formfield>
				<kendo-label [for]="email" text="Email"></kendo-label>
				<input formControlName="email" kendoTextBox #email required />
				<kendo-formerror>Please enter your email address</kendo-formerror>
			</kendo-formfield>
			<kendo-formfield>
				<kendo-label [for]="code" text="">Activation Code</kendo-label>
				<input formControlName="code" kendoTextBox #code required />
				<kendo-formerror>Please enter your confirmation code</kendo-formerror>
			</kendo-formfield>
			<kendo-formfield>
				<kendo-label [for]="password" text="Password"></kendo-label>
				<input formControlName="password" type="password" kendoTextBox #password required />
				<kendo-formerror>Please enter your password</kendo-formerror>
			</kendo-formfield>
			<password-strength-meter [minPasswordLength]="8" [enableFeedback]="true"
				(strengthChange)="passwordStrengthChanged($event)" [password]="password?.value">
			</password-strength-meter>
			<div class="k-form-buttons">
				<button kendoButton themeColor="primary" (click)="submitForm()" [disabled]="loading">Reset Password</button>
			</div>
		</fieldset>
		<div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
		<p class="mt-3 login-wrapper-footer-text"><a routerLink="/login" class="text-reset">Back to Login</a>
		</p>
	</form>

</div>